import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class SlideNavigationService {
    currentNavItem$: Subject<any> = new BehaviorSubject<any>({path: 'mc'});
    currentPath: string;
    currentNavItem: INavItem;

    constructor(private _router: Router) {
        this.currentNavItem$.subscribe(navItem => {
            if (navItem.service && navItem.service.gettingIntoTracing$) {
                navItem.service.gettingIntoTracing$.next();
            }
            this.currentPath = navItem.path;
            _router.navigateByUrl(navItem.path);
           
        });
    }
} 

